import { api } from "roboflex-thalamus-request-handler";

function obterTodos(){
    return new Promise((resolve, reject) => {
        return api.get('pessoa')
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
}

function atualizarResponsavel(payload){
    return new Promise ((resolve, reject) => {
        //         {
        //     "catDRE_id": 605,
        //     "tipo": "Solicitante",
        //     "usuario_id": 4
        //     "setor_id": 2
        // Quando for setor mandar o setor_id, os demais tipos manda usuario_id
        // }
        return api.post(`dre/categoria/associar/responsavel`,payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
    })
}


function desvincular(id_vinculo){
    return new Promise ((resolve, reject) => {
        return api.delete(`dre/categoria/desassociar/responsavel/${id_vinculo}`)
        .then(response => resolve(response))
        .catch(error => reject(error));
    })
}

function obterTodosSetores(){
    return new Promise((resolve, reject) => {
        return api.get('setor/hierarquico')
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
}


export default {
    obterTodos,
    atualizarResponsavel,
    obterTodosSetores,
    desvincular
   
}